import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { forkJoin } from 'rxjs';
import { DEFAULT_USERNAME } from 'src/app/extensions/constants/commonConstants';
import { CLIENT_DATA_WRITE_RIGHTS } from 'src/app/extensions/constants/right-constants';
import { PartnerAPIService } from 'src/app/extensions/services/api/partner-api.service';
import { UserAPIService } from 'src/app/extensions/services/api/user-api.service';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';

@Component({
  selector: 'my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
  standalone: false,
})
export class MyProfileComponent implements OnInit {
  isAdmin: boolean = false;
  profileData: app.models.ProfileModel = { username: DEFAULT_USERNAME, partner: {} } as app.models.ProfileModel;
  partnerAdresses: app.models.AddressProfileModel[];
  partnerBankAccounts: app.models.BankAccountProfileModel[];
  requestTypes: app.models.DictionaryRequestType[];

  userRights: string[];
  readOnly: boolean = true;
  dataLoaded: boolean = false;

  constructor(
    private _globalService: GlobalService,
    private _userAPIService: UserAPIService,
    private _partnerAPIService: PartnerAPIService,
    private _dictionaryAPIService: DictionaryAPIService
  ) {}

  ngOnInit(): void {
    this.isAdmin = this._globalService.isAdminUser();

    var userInfo = forkJoin([this._userAPIService.getCurrentUserProfileInfo(), this._userAPIService.getUserRights()]);

    userInfo.subscribe(([userData, userRights]) => {
      this.profileData = userData;
      this.userRights = userRights.rights.map(x => x.code);
      this.readOnly = !this.userRights.some(userRight => CLIENT_DATA_WRITE_RIGHTS.includes(userRight));
      if (this.isAdmin) this.dataLoaded = true;
    });

    if (!this.isAdmin) {
      var partnerInformation = forkJoin([
        this._partnerAPIService.getCurrentPartnerProfileInfo(),
        this._partnerAPIService.getCurrentPartnerAdresses(),
        this._partnerAPIService.getCurrentPartnerBankAccounts(),
        this._dictionaryAPIService.getDictionaryRequestType(),
      ]);

      partnerInformation.subscribe(([partnerData, partnerAdresses, partnerBankAccounts, requestTypes]) => {
        this.profileData.partner = partnerData;
        this.partnerAdresses = partnerAdresses;
        this.partnerBankAccounts = partnerBankAccounts;
        this.requestTypes = requestTypes;
        this.dataLoaded = true;
      });
    }
  }
}
